export const SPECIFIC_STOCK_FOUND = 'SPECIFIC_STOCK_FOUND';
export const SPECIFIC_STOCK_CLEAR = 'SPECIFIC_STOCK_CLEAR';
export const SET_VALUE = 'SET_VALUE';
export const UPDATE_AUTOCOMPLETEARRAY = 'UPDATE_AUTOCOMPLETEARRAY';